module.exports = __webpack_public_path__ + "img/material_selection.6947a0d.jpg";